import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'coupon-center',
  name: '领券中心',
  icon: '券',
  group: '营销组件',
  description: '整页展示公开可领优惠券并支持一键领取',
  defaultProps: {
    title: '领券中心'
}
}
